module.exports = __webpack_public_path__ + "public/images/prizes/prize-thailand.2766c6fa7fcfb4df9b31b1d85caf0f59.png";